module.exports = __webpack_public_path__ + "static/media/FeedVax.9ae01302.png";